var _linearGradient, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinElectric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6D49D4",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "6%",
    stopColor: "#6D49D4",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6D49D4",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 37.2C20 35.985 19.0093 35.017 17.8071 34.8409C10.5623 33.7796 5 27.5394 5 20C5 11.7157 11.7157 5 20 5C27.5394 5 33.7796 10.5623 34.8409 17.8071C35.017 19.0093 35.985 20 37.2 20C38.7464 20 40.0206 18.7393 39.8066 17.2078C38.4483 7.48388 30.0981 0 20 0C8.9543 0 0 8.9543 0 20C0 30.0981 7.48388 38.4483 17.2078 39.8066C18.7393 40.0206 20 38.7464 20 37.2Z",
    fill: "#7575CD"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#paint0_linear)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinElectric);
export default __webpack_public_path__ + "static/media/spin-electric.d25b39331acc025cdd15891a44c982a2.svg";
export { ForwardRef as ReactComponent };